import jQuery from 'jquery';

export class NavToggle {
    constructor(container) {
        this.$container = jQuery(container);
    }

    init() {
        this.$container.on('click', (event) => {
            event.preventDefault();
            const that = event.currentTarget;
            const navWrapper = jQuery(that).parent().find('.header__menu');

            jQuery(that).find('.header__nav-icon').toggleClass('open');
            navWrapper.toggleClass('opened');
        });
    }
}

export class StickyHeader {
    constructor(container) {
        this.$container = jQuery(container);
    }

    init() {
        function headerShadow(element) {
            const scrollTop = jQuery(window).scrollTop();
            if (scrollTop > 0) element.addClass('sticky');
            else element.removeClass('sticky');
        }

        headerShadow(this.$container);
        jQuery(window).scroll(() => {
            headerShadow(this.$container);
        });
    }
}
